import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@services/baseQuery';
import { handleError } from '../utils/api-error-handling';

export const databaseApi = createApi({
  reducerPath: 'databaseApi',
  baseQuery: baseQuery,
  tagTypes: ['Database'],
  endpoints: (builder) => ({
    resetDatabase: builder.mutation({
      query: () => ({
        url: 'configuration/database/reset',
        method: 'POST',
      }),
      invalidatesTags: ['Database'],
      transformErrorResponse: async (baseQueryReturnValue: any) => {
        return handleError(baseQueryReturnValue);
      },
    }),
  }),
});

export const { useResetDatabaseMutation } = databaseApi;
